import navMenu from "../../common/NavMenu.js";

export default () => {
  document.querySelectorAll(".js-secondary-nav").forEach((el, index) => {
    const config = {
      animationDelay: 500,
      closed: true,
      direction: "vertical",
      menuButton: ".js-nav-toggle",
      menuContainer: ".js-menu",
      menuLink: ".js-menu a[href]",
      openClass: "is-open",
      onClose: null,
      onOpen: null,
      parent: el,
    };

    navMenu(config);
  });
};
